





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { FormDesignerControlCode } from "@/enums/FormDesignerControlCode";
import FormDesignerPreviewControl from "@/components/formDesigner/formDesignerPreviewControl.vue";
import TramiteBeneficiarioContent, {
  TramiteBeneficiarioContentAttribute
} from "@/models/tramite/content/tramiteBeneficiarioContent.model";
import BaseSetting, {
  SectionSetting,
  InputSetting
} from "@/models/formDesigner/formDesignerControl.model";
import { ComponentDesignConfig } from "@/models/tipoTramite";
import { ComponentDesignConfigAttribute } from "@/models/componentDesignConfig.model";

@Component({
  name: "tramiteBeneficiarioContent",
  components: { FormDesignerPreviewControl }
})
export default class TramiteBeneficiarioContentComponent extends BaseVue {
  @Prop() readonly config!: ComponentDesignConfig;
  model = new TramiteBeneficiarioContent(this.config.id);
  content: SectionSetting = this.map<SectionSetting>(
    JSON.parse(this.config.configuration)
  );

  destroyed() {
      this.$emit("change", undefined);
  }
  @Watch("content", { deep: true, immediate: true })
  onModelChange(value: SectionSetting) {
    this.model.attributes = [];
    value.controls.forEach(element => this.getAttributes(element));
    this.$emit("change", this.model);
  }

  get previewControls() {
    let refs = this.$refs.previewControls as any;
    if (!refs) return [];
    return Array.isArray(refs) ? refs : [refs];
  }

  public async isValid() {
    let isValid = true;
    for (const control of this.previewControls) {
      if (typeof control.isValid !== "function") continue;

      let controlValid = await control.isValid();
      if (!controlValid) isValid = false;
    }
    return isValid;
  }

  onSectionControlInput(
    controls: BaseSetting[],
    index: number,
    value: BaseSetting
  ) {
    controls.splice(index, 1, value);
  }

  getAttributes(
    value: BaseSetting,
    parent?: TramiteBeneficiarioContentAttribute
  ) {
    let copy = this.copy(value) as SectionSetting;
    let attrc = this.findAttr(this.config.attributes, value.guid) as ComponentDesignConfigAttribute;
    let attribute = new TramiteBeneficiarioContentAttribute(value.name,copy.modelType,attrc.id);
    switch (copy.modelType) {
      case "section":
        if(attrc.componentDesignConfigId) this.model.attributes.push(attribute);

          copy.controls.forEach(element => this.getAttributes(element, attribute));
        break;
      case "string":
        attribute.valorString = copy.model;
        break;
      case "number":
        attribute.valorInt = copy.model;
        break;
      case "boolean":
        attribute.valorBooleano = copy.model;
        break;
      case "file":
        attribute.valorDoc = copy.model;
        break;
      case "date":
        attribute.valorDate = copy.model;
        break;
      default:
        break;
    }
      if (parent) {
        if (!parent.attributes) 
            parent.attributes = [];
          
        parent.attributes.push(attribute);
      }
  }

  findAttr(attributes: ComponentDesignConfigAttribute[], guid: string):ComponentDesignConfigAttribute| undefined {
    let attrM: ComponentDesignConfigAttribute | undefined = undefined;
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      if (attr.guid == guid) {
        attrM = attr;
        break;
      }
    }

    if (!attrM) {
      for (let i = 0; i < attributes.length; i++) {
        const attr = attributes[i];
        attrM = this.findAttr(attr.attributes, guid);
        if (attrM) {
          break;
        }
      }
    }
    return attrM;
  }
}
